import { createIcon } from "@chakra-ui/react";

const MoreIcon = createIcon({
  displayName: "MoreIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M5 10.5C4.17157 10.5 3.5 11.1716 3.5 12C3.5 12.8284 4.17157 13.5 5 13.5C5.82843 13.5 6.5 12.8284 6.5 12C6.5 11.1716 5.82843 10.5 5 10.5Z"
        fill="currentColor"
      />
      <path
        d="M10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12Z"
        fill="currentColor"
      />
      <path
        d="M19 10.5C18.1716 10.5 17.5 11.1716 17.5 12C17.5 12.8284 18.1716 13.5 19 13.5C19.8284 13.5 20.5 12.8284 20.5 12C20.5 11.1716 19.8284 10.5 19 10.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export default MoreIcon;
